export const ALLOCATE_TIMEBLOCK = 'SESSION_WIZARD:ALLOCATE_TIMEBLOCK';
export const RELEASE_TIMEBLOCK = 'SESSION_WIZARD:TIMEBLOCK_EXPIRED';